import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'



export default {
    namespaced: true,
    state: {
        listOHistoryOrders : [],
    },

    getters: {
    },

    mutations: {
        setlistOHistoryOrders (state, listOHistoryOrders) {
            state.listOHistoryOrders  = listOHistoryOrders
        },

    },

    actions: {
        /* eslint-disable no-console */
        clearListOHistoryOrders({commit}){
            commit('setlistOHistoryOrders', [])
            // console.log('do setlistOHistoryOrders')
        },
        fetchListOHistoryOrders({commit},idopd) {
            const datTo = {
                "idopd":idopd ,
            }
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofhistoryorderlabbyidopd`,datTo,getConfigAxios())
                    .then((res)=>{
                       commit('setlistOHistoryOrders', res.data)
                       resolve(res)
                    })
                    .catch((err)=>{
                        reject(err)
                    })

            })
        }

    }
}